<template>
  <div class="hearder">
    <div class="app-wrapper top">
      <h1>
        <a
          @click="
            () => {
              $router.push({ path: '/' })
            }
          "
        >
          <img src="../../assets/top_logo.png" />
        </a>
      </h1>
      <div class="top_rt nav_mod">
        <a
          href="#"
          v-for="(item, index) in MENU_LIST"
          :key="index"
          :class="activeIndex == item.id ? 'isCurrent' : ''"
          @click="handleChangeMenu(item.path)"
        >
          {{ item.name }}
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import { MENU_LIST } from '@/constants/common'
import { getToken } from '@/utils/token'

export default {
  name: 'hearder',
  data() {
    return {
      getToken,
      MENU_LIST,
      activeIndex: '1'
    }
  },
  watch: {
    $route: {
      immediate: true,
      handler(to, from) {
        let code = to.path.split('/')[1] || 'home'
        let num = this.MENU_LIST.findIndex((n) => n.code === code)
        if (num !== -1) {
          this.activeIndex = this.MENU_LIST[num].id
        } else {
          this.activeIndex = '10'
        }
      }
    }
  },
  methods: {
    handleChangeMenu(val) {
      this.$router.push({ path: val })
    }
  }
}
</script>

<style lang="scss" scoped>
.hearder {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  background-color: #f4f9ef;
  z-index: 999;
  height: 80px;
  background: rgba(255, 255, 255, 0.7);
  box-shadow: 0px 0px 24px 0px rgba(92, 72, 11, 0.2);
}
.top {
  height: 80px;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  h1 {
    display: flex;
    align-items: center;
    a {
      line-height: 24px;
      font-size: 20px;
      display: flex;
      align-items: center;
      color: #333;
      img {
      }
    }
    span {
      color: #333;
      font-size: 24px;
      margin-left: 20px;
    }
  }
  .top_rt {
    display: flex;
    align-items: center;
  }
}
.rt {
  height: 42px;
  line-height: 42px;
}
.rt i {
  color: #c3401a;
  margin-right: 6px;
}
.rt a {
  margin-left: 20px;
}
.banner_img img {
  width: 100%;
  min-height: 500px;
}
.banner_content {
  display: flex;
  align-items: center;
}
.nav_mod {
  overflow: hidden;
  a {
    font-size: 16px;
    font-weight: 600;
    color: #a72126;
    padding: 10px 20px;
    margin: 0 10px;
    position: relative;
    text-align: center;
    line-height: 36px;
  }
  a.isCurrent::before {
    content: '';
    width: 28px;
    height: 3px;
    background: #a72126;
    border-radius: 2px;
    position: absolute;
    top: 45px;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}
@media screen and (max-width: 750px) {
  .hearder {
    position: relative;
  }
  .top {
    display: block;
    h1 img {
      width: 100%;
    }
    .top_rt {
      margin-top: 0;
    }
    .nav_mod {
      padding-top: 0;
      display: flex;
      a {
        display: block;
        flex: 1;
        text-align: center;
        margin: 0 5px;
        line-height: 30px;
        padding: 0;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/layout/components/hearder.vue